var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStruts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-17 0 290 290",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M241.026415,73.9018868 L130.415094,9.66037736 L9.66037736,77.2830189 L9.66037736,212.528302 L130.415094,280.150943 L246.339623,212.528302 L246.339623,77.2830189 L246.339623,71.4867925 L241.026415,73.9018868 Z",
    fill: "#202A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66037736,77.2830189 L130.415094,144.90566 L246.339623,77.2830189 L130.415094,9.66037736 L9.66037736,77.2830189 Z",
    fill: "#2C448A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.339623,71.4867925 L207.698113,91.7735849 L207.215094,100.467925 L130.415094,144.90566 L130.415094,280.150943 L246.339623,212.528302 L246.339623,71.4867925 Z",
    fill: "#283A79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66037736,77.2830189 L9.66037736,212.528302 L130.415094,280.150943 L130.415094,144.90566 L9.66037736,77.2830189 Z",
    fill: "#202A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,212.528302 L0,169.056604 L130.415094,246.339623 L130.415094,289.811321 L0,212.528302 Z",
    fill: "#3558A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,77.2830189 L0,101.433962 L130.415094,178.716981 L130.415094,154.566038 L0,77.2830189 Z",
    fill: "#3558A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,212.528302 L256,188.377358 L150.218868,142.490566 L130.415094,154.566038 L130.415094,178.233962 L194.656604,206.732075 L130.415094,246.339623 L130.415094,289.811321 L256,212.528302 Z",
    fill: "#416FB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.656604,206.732075 L186.928302,203.833962 L130.415094,236.679245 L9.66037736,169.056604 L9.66037736,163.260377 L0,169.056604 L130.415094,246.339623 L194.656604,206.732075 Z",
    fill: "#477FC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9962264,86.9433962 L130.415094,43.4716981 L207.698113,91.7735849 L246.339623,71.4867925 L130.415094,0 L0,77.2830189 L130.415094,154.566038 L150.218868,142.490566 L56.9962264,86.9433962 Z",
    fill: "#477FC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.215094,100.467925 L207.698113,91.7735849 L130.415094,43.4716981 L56.9962264,86.9433962 L65.2075472,91.7735849 L130.415094,53.1320755 L207.215094,100.467925 Z",
    fill: "#202A5A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStruts);
export default __webpack_public_path__ + "static/media/struts.b2add4496a0dc174e4111cd8d8b204bc.svg";
export { ForwardRef as ReactComponent };